import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MenuContainer } from './styles'
import LanguageSelector from '../LanguageSelector'

const showClientArea = true

const Menu = (props) => {
  const { isOpened, isScrolled, handleClick } = props

  const { t } = useTranslation()
  
  const handleClickClient = () => {
    window.open('https://gestao.spartacusbrazil.com.br/spt/open.do?sys=SPT', '_blank')
  }

  return (
    <MenuContainer className={`${isOpened ? 'mobile' : ''} ${isScrolled ? 'scrolled' : ''}`}>
      <ul className={showClientArea ? '' : 'no-client'}>
        <li>
          <NavLink
            to="/"
            activeclassname="active"
            onClick={handleClick}
          >
            {!isScrolled && (<i className="fas fa-home" />)}
            <span>HOME</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/quem-somos"
            activeclassname="active"
            onClick={handleClick}
          >
            {!isScrolled && (<i className="far fa-building" />)}
            <span>{t('QUEM SOMOS')}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/servicos"
            activeclassname="active"
            onClick={handleClick}
          >
            {!isScrolled && (<i className="fas fa-shield" />)}
            <span>{t('SERVIÇOS')}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/contato"
            activeclassname="active"
            onClick={handleClick}
          >
            {!isScrolled && (<i className="fas fa-at" />)}
            <span>{t('CONTATO')}</span>
          </NavLink>
        </li>
      </ul>
      <LanguageSelector isOpened={isOpened} />
      {showClientArea && (
        <button className='button' onClick={handleClickClient}>
          {!isScrolled && (<i className="fas fa-user-lock" />)}
          <span>{t('ACESSO CLIENTE')}</span>
        </button>
      )}
    </MenuContainer>
  )
}

Menu.propTypes = {
  isOpened: PropTypes.bool,
  isScrolled: PropTypes.bool,
  handleClick: PropTypes.func,
}

Menu.defaultProps = {
  isOpened: false,
  isScrolled: false,
  handleClick: null,
}

export default Menu
